import { ClientEntity } from './ClientEntity'

export class ClientStation extends ClientEntity {
  static type = 'station'

  getInteractInfo() {
    return this.data.interact
  }

  init() {
    const c = this.data.collider
    this._sprite = this.world.sprites.add({
      x: this.data.position.x,
      y: this.data.position.y,
      yBase: this.data.position.yBase,
      url: this.data.sprite.url,
      width: this.data.sprite.width,
      height: this.data.sprite.height,
    })
    this._collider = this.world.physics.add(
      this.data.position.x,
      this.data.position.y,
      {
        type: 'solid',
        ox: c.ox,
        oy: c.oy,
        w: c.w,
        h: c.h,
      },
      this
    )
    if (this.data.shadow) {
      this._shadow = this.world.shadows.add({
        x: this.data.position.x,
        y: this.data.position.y,
        url: this.data.shadow.url,
        width: this.data.sprite.width,
        height: this.data.sprite.height,
      })
    }
    const t = this.data.target || {}
    this._action = this.world.targets.add({
      px: this.data.position.x,
      py: this.data.position.y,
      ox: t.ox,
      oy: t.oy,
      radius: t.radius || 0,
      value: this,
    })
  }

  onChange(changes) {
    if (changes.position) {
      this._sprite?.setPosition(this.data.position.x, this.data.position.y)
      this._collider?.setPosition(this.data.position.x, this.data.position.y)
      this._action?.setPosition(this.data.position.x, this.data.position.y)
    }
  }

  canInteract() {
    return true
  }

  destroy() {
    this._action?.destroy()
    this._collider?.destroy()
    this._sprite?.destroy()
    this._shadow?.destroy()
    super.destroy()
  }
}
